export default "/assets/images/home-wrecker1.png?4394cf26365cfe596686dce7e07a6ca9";